import { render, staticRenderFns } from "./MatchesTable.vue?vue&type=template&id=25fe9f21&scoped=true&"
import script from "./MatchesTable.vue?vue&type=script&lang=js&"
export * from "./MatchesTable.vue?vue&type=script&lang=js&"
import style0 from "./MatchesTable.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./MatchesTable.vue?vue&type=style&index=1&id=25fe9f21&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fe9f21",
  null
  
)

export default component.exports